'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var reduceRightAsync = function () {
  var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(elements, callback) {
    var i,
        element,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            i = elements.length - 1;
            element = _args.length <= 2 ? undefined : _args[2];

            if ((_args.length <= 2 ? 0 : _args.length - 2) === 0) element = elements[i--];

          case 3:
            if (!(i >= 0)) {
              _context.next = 10;
              break;
            }

            _context.next = 6;
            return callback(element, elements[i], i, elements);

          case 6:
            element = _context.sent;

          case 7:
            i--;
            _context.next = 3;
            break;

          case 10:
            return _context.abrupt('return', element);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function reduceRightAsync(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();

exports.default = createBySchema;

var _isNil = require('coact-utils/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _isPlainObject = require('coact-utils/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isEmpty = require('coact-utils/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _transformWithSchema = require('../transformWithSchema');

var _transformWithSchema2 = _interopRequireDefault(_transformWithSchema);

var _createTempId = require('../createTempId');

var _createTempId2 = _interopRequireDefault(_createTempId);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var isArray = Array.isArray;

function emptyValueCreator(value) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') return value;

  return value === undefined ? null : value;
}

function shouldTreatAsEmpty(value) {
  return (0, _isNil2.default)(value) || value === '' || (0, _isPlainObject2.default)(value) && (0, _isEmpty2.default)(value) || isArray(value) && (0, _isEmpty2.default)(value);
}
function autofillValueCreator(value, _ref, _ref2) {
  var creator = _ref.creator;
  var server = _ref2.server;

  if (creator === undefined) return value;
  if (!shouldTreatAsEmpty(value)) return value;
  if (typeof creator === 'function') return value;

  if (creator === '$$NOW') return server.now();
  if (creator === '$$TODAY') {
    return server.now().then(function (now) {
      return (0, _moment2.default)(now).startOf('day').toDate();
    });
  }

  return creator;
}

function defaultValueCreator(value, _ref3) {
  var autogeneratable = _ref3.autogeneratable;

  if (!autogeneratable) return value;

  return (0, _createTempId2.default)();
}

function nocloneFilter(value, _ref4) {
  var noclone = _ref4.noclone;

  if (noclone) return null;
  return value;
}

function useCustomCreator(value, schema, ctx) {
  var creator = schema.creator;

  if (typeof creator !== 'function') return value;

  return creator(value, schema, ctx);
}

function composeCreators(creators) {
  return function (value, schema, ctx) {
    return reduceRightAsync(creators, function (val, creator) {
      return creator(val, schema, ctx);
    }, value);
  };
}

var transform = composeCreators([useCustomCreator, defaultValueCreator, autofillValueCreator, emptyValueCreator, nocloneFilter]);

function createBySchema(schema) {
  var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var value = arguments[2];

  return (0, _transformWithSchema2.default)(schema)(ctx)(transform)(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/creation/createBySchema.js
// module id = 1758
// module chunks = 0